import { api } from "./api";

// Unwraps an optional generateResponse(status, message, code, data) envelope.
// store-list's own `data` field is the row array, so it passes through as-is.
function pickData(body) {
  const d = body || {};
  return d && typeof d === "object" && "data" in d && !Array.isArray(d.data)
    ? d.data
    : d;
}

function buildParams(obj) {
  const out = {};
  Object.keys(obj || {}).forEach((k) => {
    const v = obj[k];
    if (v === null || v === undefined || v === "") return;
    out[k] = v;
  });
  return out;
}

export async function fetchCocoStoreDashboardCounts() {
  const res = await api.get("/coco-store/overview/dashboard-counts");
  return pickData(res.data);
}

export async function fetchCocoStoreList({
  page,
  limit,
  search,
  search_column,
  creator_id,
  city,
  state,
  rent_status,
  sd_status,
  created_from,
  created_to,
  sortBy,
  sortOrder,
} = {}) {
  const res = await api.get("/coco-store/overview/store-list", {
    params: buildParams({
      page,
      limit,
      search,
      search_column,
      creator_id,
      city,
      state,
      rent_status,
      sd_status,
      created_from,
      created_to,
      sortBy,
      sortOrder,
    }),
  });
  return pickData(res.data);
}

export async function fetchCocoStoreFilterData() {
  const res = await api.get("/coco-store/overview/filter-data");
  return pickData(res.data);
}

export async function fetchCocoStoreAnalytics() {
  const res = await api.get("/coco-store/overview/analytics");
  return pickData(res.data);
}
